const ERROR_MESSAGE_BEGINNING = 'error_promotion_overridden_by_bogo'

export const isBogoPromotionNonAppliedError = (message: string) =>
  ERROR_MESSAGE_BEGINNING === message
